import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles/global.css';
import './i18n/config.js';

// Initialize Firebase (Analytics, Firestore, FCM)
import { trackError } from './services/firebase.js';

import * as Sentry from '@sentry/react';
import { onCLS, onLCP, onINP, onFCP, onTTFB } from 'web-vitals';

// Initialize Sentry for comprehensive monitoring
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || '',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0, 
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0, 
});

// Send Core Web Vitals to Firebase / Console
const sendToAnalytics = (metric) => {
  console.log('Web Vitals:', metric);
  // Example: log to Custom Analytics API or Firebase if configured for events
};
onCLS(sendToAnalytics);
onLCP(sendToAnalytics);
onINP(sendToAnalytics);
onFCP(sendToAnalytics);
onTTFB(sendToAnalytics);

// Global error tracking (web alternative to Crashlytics)
window.addEventListener('error', (event) => {
  trackError(event.error, 'window.onerror');
});
window.addEventListener('unhandledrejection', (event) => {
  trackError(event.reason, 'unhandledrejection');
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
